"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// thanks http://www.yearofmoo.com/2013/08/remastered-animation-in-angularjs-1-2.html

ngModule.animation('.anim-slide', function () {
  return {
    enter: function enter(element, done) {
      done();
    },
    leave: function leave(element, done) {
      done();
    },
    move: function move(element, done) {
      done();
    },
    addClass: function addClass(element, className, done) {
      if (className !== "ng-hide") {
        return done();
      }
      element.slideUp({}, done);
      return function (canceled) {
        if (canceled) {
          // element.stop(); // PGA : need to check how to delete height attribute on cancel. else it's buggy at startup.
        }
      };
    },
    removeClass: function removeClass(element, className, done) {
      if (className !== "ng-hide") {
        return done();
      }
      element.removeClass('ng-hide');
      element.slideDown({}, done);
      return function (canceled) {
        if (canceled) {
          // element.stop(); // PGA : see addClass.
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/animations/anim-slide.js
// module id = 2914
// module chunks = 13